
// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { TextField, Button, CircularProgress, Stack } from '@mui/material';
// import { useSnackbar } from 'notistack';
// import axios from 'axios';
// import './Login.css';

// function Login() {
//   const navigate = useNavigate();
//   const { enqueueSnackbar } = useSnackbar();

//   const [formData, setFormData] = useState({ email: '', password: '' });
//   const [loading, setLoading] = useState(false);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const validateEmail = (email) => /\S+@\S+\.\S+/.test(email);

//   const handleSubmit = async () => {
//   const { email, password } = formData;

//   if (!email || !password) {
//     enqueueSnackbar('Both fields are required.', { variant: 'warning' });
//     return;
//   }

//   if (!validateEmail(email)) {
//     enqueueSnackbar('Invalid email format.', { variant: 'warning' });
//     return;
//   }

//   if (password.length < 6) {
//     enqueueSnackbar('Password must be at least 6 characters.', { variant: 'warning' });
//     return;
//   }

//   try {
//     setLoading(true);
//     const response = await axios.post(
//       `${process.env.REACT_APP_BASE_URL}auth/login`,
//       { email, password },
//       { headers: { 'Content-Type': 'application/json' } }
//     );
//     const data = response.data;
//     localStorage.setItem('user', JSON.stringify({ email, token: data.access_token }));
//     enqueueSnackbar('Logged in successfully', { variant: 'success' });
//     navigate('/dashboard');
//   } catch (err) {
//     let errorMsg = 'Login failed. Please try again.';
//     if (err.response?.status === 401) {
//       errorMsg = 'Invalid credentials';
//     } else if (err.response?.data?.message) {
//       errorMsg = err.response.data.message;
//     }
//     enqueueSnackbar(errorMsg, { variant: 'error' });
//   } finally {
//     setLoading(false);
//   }
// };

//   return (
//     <div className="wrapper">
//       <div className="image-section" />
//       <div className="form-section">
//         <Stack spacing={2} className="form">
//           <h1>Login</h1>
//           <TextField
//             label="Email"
//             name="email"
//             type="email"
//             fullWidth
//             value={formData.email}
//             onChange={handleChange}
//             placeholder="Enter your email"
//           />
//           <TextField
//             label="Password"
//             name="password"
//             type="password"
//             fullWidth
//             value={formData.password}
//             onChange={handleChange}
//             placeholder="Enter your password"
//           />
//           {loading ? (
//             <CircularProgress />
//           ) : (
//             <Button variant="contained" onClick={handleSubmit} className="button">
//               LOGIN
//             </Button>
//           )}
//         </Stack>
//       </div>
//     </div>
//   );
// }

// export default Login;



// import { useState } from 'react';
// import { motion } from 'framer-motion';
// import nccfLogo from "../assets/nccflogo.jpg"
// import loginVisual from '../assets/backgr.jpg'
// import stayamevlogo from '../assets/satyamev jayate logo.jpg'

// export default function LoginPage() {
//   const [username, setUsername] = useState('');
//   const [password, setPassword] = useState('');

//   const handleLogin = (e) => {
//     e.preventDefault();
//     // Submit logic here
//   };

//   return (
//     <div className="min-h-screen flex flex-col bg-[#eef2fc]">
      

//       <header className="w-full bg-white py-2 px-6 shadow-sm border-b border-gray-200 flex justify-between items-center">
//       {/* Left - NCCF */}
//       <div className="flex items-start gap-3">
//         <img src={nccfLogo} alt="NCCF Logo" className="h-12 mt-1" />
//         <div className="text-sm text-gray-700 leading-tight">
//           <p className="font-semibold">National Cooperative Consumers’ Federation of India Ltd</p>
//           <p>(Under Ministry of Consumer Affairs: Food & Public Distribution)</p>
//           <p className="text-[13px] font-medium text-gray-600">भारत सरकार | Government of India</p>
//         </div>
//       </div>

//       {/* Right - Department of Consumer Affairs */}
//       <div className="flex items-center gap-3 text-right">
//         <div className="text-sm leading-tight">
//           <p className="font-medium">उपभोक्ता मामले विभाग</p>
//           <p className="uppercase font-bold text-[13px]">Department of <br /> Consumer Affairs</p>
//         </div>
//         <img src={stayamevlogo} alt="Gov Emblem" className="h-10" />
//       </div>
//     </header>

//       {/* Main Content */}
//       <main className="flex flex-1 flex-col md:flex-row items-center justify-center p-4 gap-8">
//         {/* Left Visual */}
//         <motion.div
//           className="hidden md:block md:w-1/2 max-w-3xl"
//           initial={{ opacity: 0, x: -40 }}
//           animate={{ opacity: 1, x: 0 }}
//           transition={{ duration: 0.6 }}
//         >
//           <img src={loginVisual} alt="Visual" className="w-full rounded-lg shadow-md" />
//         </motion.div>

//         {/* Right Login Card */}
//         <motion.div
//           className="bg-white p-8 rounded-2xl shadow-lg w-full max-w-md"
//           initial={{ opacity: 0, x: 40 }}
//           animate={{ opacity: 1, x: 0 }}
//           transition={{ duration: 0.6 }}
//         >
//           <div className="flex justify-center mb-6">
//             <img src={nccfLogo} alt="NCCF Logo" className="h-12" />
//           </div>
//           <form onSubmit={handleLogin} className="space-y-5">
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">Username *</label>
//               <input
//                 type="text"
//                 value={username}
//                 onChange={(e) => setUsername(e.target.value)}
//                 required
//                 className="w-full px-4 py-2 border border-gray-300 rounded-full focus:ring-2 focus:ring-blue-500 outline-none"
//               />
//             </div>
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">Password *</label>
//               <input
//                 type="password"
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 required
//                 className="w-full px-4 py-2 border border-gray-300 rounded-full focus:ring-2 focus:ring-blue-500 outline-none"
//               />
//             </div>
//             <button
//               type="submit"
//               className="w-full bg-[#2dbfa8] hover:bg-[#25a895] text-white font-medium py-2 rounded-full shadow-md transition"
//             >
//               Login
//             </button>
//           </form>
//         </motion.div>
//       </main>

//       {/* Footer */}
//       <footer className="text-center py-3 text-sm text-gray-500 bg-white shadow-inner">
//         © {new Date().getFullYear()} NCCF | Department of Consumer Affairs
//       </footer>
//     </div>
//   );
// }
// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useSnackbar } from 'notistack';
// import axios from 'axios';
// import { motion } from 'framer-motion';
// import nccfLogo from "../assets/nccflogo.jpg";
// import loginVisual from '../assets/backgr.jpg';
// import stayamevlogo from '../assets/satyamev jayate logo.jpg';

// export default function LoginPage() {
//   const [formData, setFormData] = useState({ email: '', password: '' });
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();
//   const { enqueueSnackbar } = useSnackbar();

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const validateEmail = (email) => /\S+@\S+\.\S+/.test(email);

//   const handleLogin = async (e) => {
//     e.preventDefault();
//     const { email, password } = formData;

//     if (!email || !password) {
//       enqueueSnackbar('Both fields are required.', { variant: 'warning' });
//       return;
//     }

//     if (!validateEmail(email)) {
//       enqueueSnackbar('Invalid email format.', { variant: 'warning' });
//       return;
//     }

//     if (password.length < 6) {
//       enqueueSnackbar('Password must be at least 6 characters.', { variant: 'warning' });
//       return;
//     }

//     try {
//       setLoading(true);
//       const response = await axios.post(
//         `${process.env.REACT_APP_BASE_URL}auth/login`,
//         { email, password },
//         { headers: { 'Content-Type': 'application/json' } }
//       );
//       const data = response.data;
//       localStorage.setItem('user', JSON.stringify({ email, token: data.access_token }));
//       enqueueSnackbar('Logged in successfully', { variant: 'success' });
//       navigate('/dashboard');
//     } catch (err) {
//       let errorMsg = 'Login failed. Please try again.';
//       if (err.response?.status === 401) {
//         errorMsg = 'Invalid credentials';
//       } else if (err.response?.data?.message) {
//         errorMsg = err.response.data.message;
//       }
//       enqueueSnackbar(errorMsg, { variant: 'error' });
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="min-h-screen flex flex-col bg-[#eef2fc]">
//       <header className="w-full bg-white py-2 px-6 shadow-sm border-b border-gray-200 flex justify-between items-center">
//         <div className="flex items-start gap-3">
//           <img src={nccfLogo} alt="NCCF Logo" className="h-12 mt-1" />
//           <div className="text-sm text-gray-700 leading-tight">
//             <p className="font-semibold">National Cooperative Consumers’ Federation of India Ltd</p>
//             <p>(Under Ministry of Consumer Affairs: Food & Public Distribution)</p>
//             <p className="text-[13px] font-medium text-gray-600">भारत सरकार | Government of India</p>
//           </div>
//         </div>
//         <div className="flex items-center gap-3 text-right">
//           <div className="text-sm leading-tight">
//             <p className="font-medium">उपभोक्ता मामले विभाग</p>
//             <p className="uppercase font-bold text-[13px]">Department of <br /> Consumer Affairs</p>
//           </div>
//           <img src={stayamevlogo} alt="Gov Emblem" className="h-10" />
//         </div>
//       </header>

//       <main className="flex flex-1 flex-col md:flex-row items-center justify-center p-4 gap-8">
//         <motion.div
//           className="hidden md:block md:w-1/2 max-w-3xl"
//           initial={{ opacity: 0, x: -40 }}
//           animate={{ opacity: 1, x: 0 }}
//           transition={{ duration: 0.6 }}
//         >
//           <img src={loginVisual} alt="Visual" className="w-full rounded-lg shadow-md" />
//         </motion.div>

//         <motion.div
//           className="bg-white p-8 rounded-2xl shadow-lg w-full max-w-md"
//           initial={{ opacity: 0, x: 40 }}
//           animate={{ opacity: 1, x: 0 }}
//           transition={{ duration: 0.6 }}
//         >
//           <div className="flex justify-center mb-6">
//             <img src={nccfLogo} alt="NCCF Logo" className="h-12" />
//           </div>
//           <form onSubmit={handleLogin} className="space-y-5">
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">Email *</label>
//               <input
//                 type="email"
//                 name="email"
//                 value={formData.email}
//                 onChange={handleChange}
//                 required
//                 className="w-full px-4 py-2 border border-gray-300 rounded-full focus:ring-2 focus:ring-blue-500 outline-none"
//               />
//             </div>
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">Password *</label>
//               <input
//                 type="password"
//                 name="password"
//                 value={formData.password}
//                 onChange={handleChange}
//                 required
//                 className="w-full px-4 py-2 border border-gray-300 rounded-full focus:ring-2 focus:ring-blue-500 outline-none"
//               />
//             </div>
//             <button
//               type="submit"
//               disabled={loading}
//               className="w-full bg-[#2dbfa8] hover:bg-[#25a895] text-white font-medium py-2 rounded-full shadow-md transition"
//             >
//               {loading ? 'Logging in...' : 'Login'}
//             </button>
//           </form>
//         </motion.div>
//       </main>

//       <footer className="text-center py-3 text-sm text-gray-500 bg-white shadow-inner">
//         © {new Date().getFullYear()} NCCF | Department of Consumer Affairs
//       </footer>
//     </div>
//   );
// }
// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import { motion } from 'framer-motion';
// import nccfLogo from "../assets/nccflogo.jpg";
// import loginVisual from '../assets/backgr.jpg';
// import stayamevlogo from '../assets/satyamev jayate logo.jpg';

// export default function LoginPage() {
//   const [formData, setFormData] = useState({ email: '', password: '' });
//   const [loading, setLoading] = useState(false);
//   const [errorMessage, setErrorMessage] = useState('');
//   const navigate = useNavigate();

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const validateEmail = (email) => /\S+@\S+\.\S+/.test(email);

//   const handleLogin = async (e) => {
//     e.preventDefault();
//     const { email, password } = formData;

//     if (!email || !password) {
//       const msg = 'Both fields are required.';
//       setErrorMessage(msg);
//       alert(msg);
//       return;
//     }

//     if (!validateEmail(email)) {
//       const msg = 'Invalid email format.';
//       setErrorMessage(msg);
//       alert(msg);
//       return;
//     }

//     if (password.length < 6) {
//       const msg = 'Password must be at least 6 characters.';
//       setErrorMessage(msg);
//       alert(msg);
//       return;
//     }

//     try {
//       setLoading(true);
//       const response = await axios.post(
//         `${process.env.REACT_APP_BASE_URL}auth/login`,
//         { email, password },
//         { headers: { 'Content-Type': 'application/json' } }
//       );

//       const data = response.data;
//       localStorage.setItem('user', JSON.stringify({ email, token: data.access_token }));
//       alert('Logged in successfully');
//       setErrorMessage('');
//       navigate('/dashboard');
//     } catch (err) {
//       let errorMsg = 'Login failed. Please try again.';
//       if (err.response?.status === 401) {
//         errorMsg = 'Invalid credentials';
//       } else if (err.response?.data?.message) {
//         errorMsg = err.response.data.message;
//       }

//       setErrorMessage(errorMsg);
//       alert(errorMsg);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="min-h-screen flex flex-col bg-[#eef2fc]">
//       <header className="w-full bg-white py-2 px-6 shadow-sm border-b border-gray-200 flex justify-between items-center">
//         <div className="flex items-start gap-3">
//           <img src={nccfLogo} alt="NCCF Logo" className="h-12 mt-1" />
//           <div className="text-sm text-gray-700 leading-tight">
//             <p className="font-semibold">National Cooperative Consumers’ Federation of India Ltd</p>
//             <p>(Under Ministry of Consumer Affairs: Food & Public Distribution)</p>
//             <p className="text-[13px] font-medium text-gray-600">भारत सरकार | Government of India</p>
//           </div>
//         </div>
//         <div className="flex items-center gap-3 text-right">
//           <div className="text-sm leading-tight">
//             <p className="font-medium">उपभोक्ता मामले विभाग</p>
//             <p className="uppercase font-bold text-[13px]">Department of <br /> Consumer Affairs</p>
//           </div>
//           <img src={stayamevlogo} alt="Gov Emblem" className="h-10" />
//         </div>
//       </header>

//       <main className="flex flex-1 flex-col md:flex-row items-center justify-center p-4 gap-8">
//         <motion.div
//           className="hidden md:block md:w-1/2 max-w-3xl"
//           initial={{ opacity: 0, x: -40 }}
//           animate={{ opacity: 1, x: 0 }}
//           transition={{ duration: 0.6 }}
//         >
//           <img src={loginVisual} alt="Visual" className="w-full rounded-lg shadow-md" />
//         </motion.div>

//         <motion.div
//           className="bg-white p-8 rounded-2xl shadow-lg w-full max-w-md"
//           initial={{ opacity: 0, x: 40 }}
//           animate={{ opacity: 1, x: 0 }}
//           transition={{ duration: 0.6 }}
//         >
//           <div className="flex justify-center mb-6">
//             <img src={nccfLogo} alt="NCCF Logo" className="h-12" />
//           </div>

//           {errorMessage && (
//             <div className="text-red-600 font-medium text-center mb-4">{errorMessage}</div>
//           )}

//           <form onSubmit={handleLogin} className="space-y-5">
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">Email *</label>
//               <input
//                 type="email"
//                 name="email"
//                 value={formData.email}
//                 onChange={handleChange}
//                 required
//                 className="w-full px-4 py-2 border border-gray-300 rounded-full focus:ring-2 focus:ring-blue-500 outline-none"
//               />
//             </div>
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">Password *</label>
//               <input
//                 type="password"
//                 name="password"
//                 value={formData.password}
//                 onChange={handleChange}
//                 required
//                 className="w-full px-4 py-2 border border-gray-300 rounded-full focus:ring-2 focus:ring-blue-500 outline-none"
//               />
//             </div>
//             <button
//               type="submit"
//               disabled={loading}
//               className="w-full bg-[#2dbfa8] hover:bg-[#25a895] text-white font-medium py-2 rounded-full shadow-md transition"
//             >
//               {loading ? 'Logging in...' : 'Login'}
//             </button>
//           </form>
//         </motion.div>
//       </main>

//       <footer className="text-center py-3 text-sm text-gray-500 bg-white shadow-inner">
//         © {new Date().getFullYear()} NCCF | Department of Consumer Affairs
//       </footer>
//     </div>
//   );
// }
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { motion } from 'framer-motion';
import nccfLogo from "../assets/nccflogo.jpg";
import loginVisual from '../assets/backgr.jpg';
import stayamevlogo from '../assets/satyamev jayate logo.jpg';

export default function LoginPage() {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();

  // 🔁 Session expired check on mount
  useEffect(() => {
    const expired = localStorage.getItem('sessionExpired');
    if (expired) {
      setErrorMessage('Session expired. Please login again.');
      localStorage.removeItem('sessionExpired');
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validateEmail = (email) => /\S+@\S+\.\S+/.test(email);

  
const handleLogin = async (e) => {
  e.preventDefault();
  const { email, password } = formData;

  // Basic validations
  if (!email || !password) {
    setErrorMessage('Both fields are required.');
    return;
  }

  if (!validateEmail(email)) {
    setErrorMessage('Invalid email format.');
    return;
  }

  if (password.length < 6) {
    setErrorMessage('Password must be at least 6 characters.');
    return;
  }

  try {
    setLoading(true);

    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}auth/login`,
      { email, password },
      { headers: { 'Content-Type': 'application/json' } }
    );

    const data = response.data;

    // Ensure user and access_token exist
    if (!data.user || !data.access_token) {
      throw new Error('Invalid login response from server.');
    }

    // Store in localStorage
    const userInfo = {
      email: data.user.email,
      token: data.access_token,
      role: data.user.role || 'user', // default to 'user'
    };
    localStorage.setItem('user', JSON.stringify(userInfo));

    // Redirect based on role
    if (userInfo.role === 'admin') {
      navigate('/dashboard');
    } else if (userInfo.role === 'user') {
      navigate('/transactions');
    } else {
      navigate('/'); // fallback
    }

  } catch (err) {
    let errorMsg = 'Login failed. Please try again.';
    if (err.response?.status === 401) {
      errorMsg = 'Invalid credentials';
    } else if (err.response?.data?.message) {
      errorMsg = err.response.data.message;
    }
    setErrorMessage(errorMsg);
  } finally {
    setLoading(false);
  }
};


  return (
    <div className="min-h-screen flex flex-col bg-[#eef2fc]">
      <header className="w-full bg-white py-2 px-6 shadow-sm border-b border-gray-200 flex justify-between items-center">
        <div className="flex items-start gap-3">
          <img src={nccfLogo} alt="NCCF Logo" className="h-12 mt-1" />
          <div className="text-sm text-gray-700 leading-tight">
            <p className="font-semibold">National Cooperative Consumers’ Federation of India Ltd</p>
            <p>(Under Ministry of Consumer Affairs: Food & Public Distribution)</p>
            <p className="text-[13px] font-medium text-gray-600">भारत सरकार | Government of India</p>
          </div>
        </div>
        <div className="flex items-center gap-3 text-right">
          <div className="text-sm leading-tight">
            <p className="font-medium">उपभोक्ता मामले विभाग</p>
            <p className="uppercase font-bold text-[13px]">Department of <br /> Consumer Affairs</p>
          </div>
          <img src={stayamevlogo} alt="Gov Emblem" className="h-10" />
        </div>
      </header>

      <main className="flex flex-1 flex-col md:flex-row items-center justify-center p-4 gap-8">
        <motion.div
          className="hidden md:block md:w-1/2 max-w-3xl"
          initial={{ opacity: 0, x: -40 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
        >
          <img src={loginVisual} alt="Visual" className="w-full rounded-lg shadow-md" />
        </motion.div>

        <motion.div
          className="bg-white p-8 rounded-2xl shadow-lg w-full max-w-md"
          initial={{ opacity: 0, x: 40 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="flex justify-center mb-6">
            <img src={nccfLogo} alt="NCCF Logo" className="h-12" />
          </div>
          <form onSubmit={handleLogin} className="space-y-5">
  <div>
    <label className="block text-sm font-medium text-gray-700 mb-1">Email *</label>
    <input
      type="email"
      name="email"
      value={formData.email}
      onChange={handleChange}
      required
      className="w-full px-4 py-2 border border-gray-300 rounded-full focus:ring-2 focus:ring-blue-500 outline-none"
    />
  </div>
  <div>
    <label className="block text-sm font-medium text-gray-700 mb-1">Password *</label>
    <input
      type="password"
      name="password"
      value={formData.password}
      onChange={handleChange}
      required
      className="w-full px-4 py-2 border border-gray-300 rounded-full focus:ring-2 focus:ring-blue-500 outline-none"
    />
  </div>
  <button
    type="submit"
    disabled={loading}
    className="w-full bg-[#2dbfa8] hover:bg-[#25a895] text-white font-medium py-2 rounded-full shadow-md transition"
  >
    {loading ? 'Logging in...' : 'Login'}
  </button>

  {/* ✅ Error Message Block */}
  {errorMessage && (
    <div className="mt-4 text-red-600 text-sm text-center bg-red-100 border border-red-300 px-4 py-2 rounded">
      {errorMessage}
    </div>
  )}
</form>

        </motion.div>
      </main>

      <footer className="text-center py-3 text-sm text-gray-500 bg-white shadow-inner">
        © {new Date().getFullYear()} NCCF | Department of Consumer Affairs
      </footer>
    </div>
  );
}
